import { useState } from "react";
import { ExternalIconSvg } from "../../../../../assets/svg";

interface ICabinInfo {
  roomInfo: any;
}

const CabinInfo: React.FC<ICabinInfo> = ({ roomInfo }) => {
  const [tabSwitch, setTabSwitch] = useState<boolean>(true);

  return (
    <>
      <div className="flex gap-3 dash-nav">
        <span
          className={`cursor-pointer ${tabSwitch ? "active" : "text-muted"}`}
          onClick={() => setTabSwitch((prev) => !prev)}
        >
          Features
        </span>
        <div className="flex gap-1.5 items-center">
          <span
            className={`cursor-pointer ${!tabSwitch ? "active" : "text-muted"}`}
            onClick={() => setTabSwitch((prev) => !prev)}
          >
            Inclusions
          </span>
          <span className="cursor-pointer" onClick={() => window.open("https://cordelia-images-prod.s3.ap-south-1.amazonaws.com/static/Inclusions+%26+Exclusions.pdf", '_blank')}><ExternalIconSvg/></span>
        </div>
      </div>
      {tabSwitch && (
        <div className="flex flex-col gap-1 text-sm font-medium">
          {roomInfo?.features?.map((feature: any, index: number) => {
            return <span key={index} className="text-wrap text-capitalize">{`• ${feature.toLowerCase()}`}</span>;
          })}
        </div>
      )}
      {!tabSwitch && (
        <div className="flex gap-5 text-sm font-medium">
          <div className="flex flex-col gap-1">
            {roomInfo?.inclusions?.map((inclusion: any, index: number) => {
              return (
                index % 2 === 0 && (
                  <span key={index} className="text-wrap text-capitalize">{`• ${inclusion.toLowerCase()}`}</span>
                )
              );
            })}
          </div>
          <div className="flex flex-col gap-1">
            {roomInfo?.inclusions?.map((inclusion: any, index: number) => {
              return (
                index % 2 !== 0 && (
                  <span key={index} className="text-wrap text-capitalize">{`• ${inclusion.toLowerCase()}`}</span>
                )
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default CabinInfo;
